import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Tours from './pages/Tours';
import Reservations from './pages/Reservations';
import Stations from './pages/Stations';
import Users from './pages/Users';
import Sales from './pages/Sales';
import LoginPage from './pages/LoginPage';

// 인증 가드
function RequireAuth({ children }) {
  const token = localStorage.getItem('admin_token');
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<RequireAuth><Layout /></RequireAuth>}>
          <Route index element={<Navigate to="/tours" replace />} />
          <Route path="tours" element={<Tours />} />
          <Route path="reservations" element={<Reservations />} />
          <Route path="stations" element={<Stations />} />
          <Route path="users" element={<Users />} />
          <Route path="sales" element={<Sales />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
